/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import { selectors as listSelectors } from '../../../redux/ducks/lists/lists';

import ProfileBloodType from './ProfileBloodType';

function mapStateToProps(state) {
  const bloodTypes = listSelectors.getBloodTypeCollection(state);

  return {
    bloodTypes,
    requestInitialData: () => {},
  };
}

export default connect(mapStateToProps)(ProfileBloodType);
